export const emailNotificationsProductGuideUrl =
  'https://www.mapistry.com/knowledge-center/email-notification-categories';

export const edpProductGuidesUrl =
  'https://www.mapistry.com/knowledge-center/the-environmental-data-platform';

export const edpJoinTypesProductGuideUrl =
  'https://www.mapistry.com/knowledge-center/join-types-in-mapistry-workflows-connect-step';

export const viewsProductGuideUrl =
  'https://www.mapistry.com/knowledge-center/understanding-log-views';
